import {ImageTile} from 'acng/core/tiles/ImageTile';

angular.module('payment').factory('BonusTile', [
  'PaymentBonus',
  'payment',
  /**
   * TODO: add correct JSDoc and types
   * @param {*} ImageTile Image Tile component
   * @param {*} PaymentBonus Payment bonus component
   * @param {*} payment Payment object
   * @returns {object} Bonus tile component
   */
  (PaymentBonus, payment) => {
    /** */
    return class BonusTile extends ImageTile {
      dontSetBg = true;
      /**
       * @param {*} scope -
       * @param {*} arg -
       */
      async load(scope, arg) {
        scope.format = arg.format || 'otm';
        if (this.image) {
          this.image.remove();
        }
        if (!this.isCompiled) {
          scope.$on('PaymentBonus', (_$event, bonus) => {
            if (scope.bonus == bonus || scope.bonus?.name == bonus?.name) {
              return;
            }
            scope.bonus = bonus;
            this.disabled = !scope.bonus;
            scope.$emit('tile.update', this);
            if (this.disabled) {
              if (arg.overlay) {
                arg.overlay.close();
              }
            }
          });
        }
        if (!payment.customerId) {
          throw 'no customer'; // warten ?? nö
        }
        if (!scope.bonus) {
          scope.bonus = await PaymentBonus.get();
        }
        if (!scope.bonus) {
          this.disabled = true;
          throw 'no bonus';
        } else {
          this.disabled = false;
        }
        await super.load(scope, {
          caption: 'payment.bonus.otmHeading',
          src: await scope.bonus.getImageUrl(scope.format),
          click: arg.noclick
            ? false
            : () => {
                if (arg.overlay) arg.overlay.close();
                scope.bonus.click();
              },
        });
        this.disabled = false;
        const oldImage = this.box.querySelector(':scope > img');
        if (oldImage) {
          oldImage.remove();
        }
        this.box.prepend(this.image);
      }
      /**
       * @returns {string} -
       */
      hookname() {
        return 'bonus';
      }
    };
  },
]);
